import { render, staticRenderFns } from "./RecordCreator.vue?vue&type=template&id=5d5d8934&scoped=true"
import script from "./RecordCreator.vue?vue&type=script&lang=js"
export * from "./RecordCreator.vue?vue&type=script&lang=js"
import style0 from "./RecordCreator.vue?vue&type=style&index=0&id=5d5d8934&prod&scoped=true&lang=scss"
import style1 from "./RecordCreator.vue?vue&type=style&index=1&id=5d5d8934&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5d8934",
  null
  
)

export default component.exports